const PersonalRecordService = {
  async savePersonalRecord(formData) {
    try {
      let url = '/api/wod/personal-record';
      let method = 'POST';
      const profileLogged = JSON.parse(localStorage.getItem('profile'));
      const { accountIdentifier } = profileLogged;
      if (formData.identifier !== undefined) {
        url = '/api/wod/personal-record/' + formData.identifier;
        method = 'PUT';
      }
      const updateData = {
        ...formData,
        profileIdentifier: profileLogged.identifier,
        type: formData.type.value,
      }
      console.log('UpdateData', updateData);
      const response = await fetch(url, {
        method: method,
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(updateData)
      });
      if (response.ok) {
        const newPersonalRecord = await response.json();
        console.log('Personal Record has been updated:', newPersonalRecord);
      }
    } catch (error) {
      console.log('Error saving PersonalRecord', error);
    }
  },
  async retrieveAllPersonalRecordsByUser() {
    try {
      const { identifier } = JSON.parse(localStorage.getItem('profile'));
      console.log(identifier);
      const response = await fetch('/api/wod/personal-record/athlete/' + identifier);
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching PersonalRecord', error);
      throw error;
    }
  },
  async retrievePersonalRecord(identifier) {
    try {
      const response = await fetch('/api/wod/personal-record/' + identifier);
      const data = await response.json();

      return data;
    } catch (error) {
      console.error('Error fetching PersonalRecord', error);
      throw error;
    }
  },
  async deletePersonalRecord(identifier) {
    try {
      let url = '/api/wod/personal-record/' + identifier;
      let method = 'DELETE';
      const response = await fetch(url, {
        method: method,
        headers: {
          'Content-Type': 'application/json'
        }
      });
      if (response.ok) {
        const newPersonalRecord = await response.json();
        console.log('Personal Record has been deleted:', newPersonalRecord);
      }
    } catch (error) {
      console.log('Error deleting PersonalRecord', error);
    }
  }
};
export default PersonalRecordService;